// extracted by mini-css-extract-plugin
export var heading = "styles-module--heading--e8f98";
export var welcome = "styles-module--welcome--22ee0";